import { pathify } from '../../utils/pathify'
import { PathnameItem, PathnameItemConstructor } from '../PathnameItem'

export class CIMSModuleItem<
  ID extends Lowercase<string> = Lowercase<string>,
  Name extends string = string,
  Pathname extends string = string
> extends PathnameItem<ID, Name, Pathname> {
  constructor(
    options: PathnameItemConstructor<ID, Name, Pathname> &
      Pick<CIMSModuleItem<ID, Name, Pathname>, 'name'>
  ) {
    super(options)
  }

  /**
   * a path to get to this module in the ui, with a leading `/`
   *
   * assumes the project match value to be `:projectId`
   */
  get projectPath() {
    return pathify(':projectId', this.pathname)
  }
}
